import React from 'react'
import Table from './Components/Table'

const DataTables = () => {
	return (
		// {/* // x---------------------------------x Data Tables Section x---------------------------------x */ }
		<div className="row" >
			<div className="col-md-12">
				<div className='card h-100'>
					<div className="rounded-4 mb-3 mb-sm-0 bg-white">
						<div className="card-body">
							<div className="px-xl-5 px-lg-4 px-3 py-3 page-body bg-card">
								<h4 className="mb-4">Datatables</h4>
								<p className="lead">react-table is a react library. It is a highly flexible tool, built upon the foundations of progressive enhancement, that adds all of these advanced features to any HTML table. </p>
								{/* // x---------------------------------x Table Section x---------------------------------x */}
								<Table />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default DataTables;